import { Injectable }     from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot }    from '@angular/router';
import { environment } from '../../../environments/environment';
import { AlertsService } from '../../shared/service/alerts.service';

@Injectable()
export class AuthGuard  
{
    redirectUrl;
    constructor (private router: Router,private alertService:AlertsService)
    {
       
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) 
    {
        let tokenData = localStorage.getItem(environment.tokenKey);
        if(tokenData)
        {
            return true;
        }
        else
        {
            this.alertService.showToast('Session Expired. Login Again','error')
            localStorage.clear()
            this.redirectUrl=state.url;
            this.router.navigate(['/']);
            return false;
        }
    }
}
